import * as React from 'react';
import { render } from 'react-dom';


import './loading.css';

import loadingLogo from '../logo/ponyStand.png'

const Loading = () => {
    return (
        <div className="loading-container">
            <img src={loadingLogo} alt="Loading..." className="loading-logo" />

            {/* <video className="loading-logo" autoPlay loop muted>
                <source src="/img/runningPony.mp4" type="video/mp4" />
                Loading...
            </video> */}
        </div> 
    );
};

export default Loading;
